import { Container, Section } from 'components/Container';
import { PartnerLink } from 'components/Links';
import { useContentfulLocale } from 'hooks/useContentfulLocale';
import { BrokerAnimation } from './BrokerAnimation';
import type { FC } from 'react';
import type { Color } from 'styled/types';

interface BrokerAnimationBlockProps {
  background?: Extract<Color, 'white' | 'cream'>;
}

export const BrokerAnimationBlock: FC<BrokerAnimationBlockProps> = ({ background = 'white' }) => {
  const {
    translations: { brokersBlockText },
  } = useContentfulLocale();

  return (
    <Container background={background}>
      <Section>
        <h2>We work with all your favourite brokers and apps</h2>
        <p>{brokersBlockText}</p>
        <br />
        <PartnerLink
          to="partners"
          asButton
          appearance="secondary"
          title="Brokers & Apps | Sharesight"
          showArrowIcon
        >
          View our partners
        </PartnerLink>
      </Section>
      <Section span={3}>
        <BrokerAnimation background={background} />
      </Section>
    </Container>
  );
};
